<template>
  <div class="agreement">
        <div class="checkbox" :class="{'checkbox-checked': checkedAgreement}"  @click="checkAgreement"> </div>
        <div class="ag-content">
          登录即代表您同意 <a @click="openAgreement(1)">用户协议 </a> 和 <a @click="openAgreement(2)">隐私政策</a>
        </div>
    </div>
</template>
<script>

export default {
  data () {
    return {
      checkedAgreement: false
    }
  },
  methods: {
    // 勾选用户协议、隐私策略
    checkAgreement () {
      this.checkedAgreement = !this.checkedAgreement
      this.$emit('agreement', this.checkedAgreement)
    },
    // 打开用户协议或者隐私策略页面地址
    openAgreement (type) {
      console.log('openAgreement :: ', type, 'process.env.NODE_ENV = ', process.env.NODE_ENV)
      let agreementURL = 'https://app.mofaxiao.com/userAgreement'
      let privacyPolicyURL = 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/ios/privacy-teacher.html?r=' + new Date().getTime()
      let openURL = ''
      const AgreementType = {
        Agreement: 1, // 用户协议
        PrivacyPolicy: 2 // 隐私策略
      }
      // 区分一下环境
      if (process.env.NODE_ENV === 'testing' || process.env.NODE_ENV === 'staging') {
        agreementURL = 'https://app-test.mofaxiao.com/userAgreement'
      }
      if (type === AgreementType.Agreement) {
        openURL = agreementURL
      } else {
        openURL = privacyPolicyURL
      }
      window.open(openURL, '_blank')
    }
  }
}
</script>
<style scoped>
  .agreement {
    margin-top: 10px;
    font-size: 12px;
    color: #626D7B;
    height: 18px;
    display:flex;
    justify-content:center;
    align-items:center;
  }

  .agreement .checkbox{
    width: 18px;
    height: 18px;
    background-image: url('../../assets/pngs/sel_normal.png');
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .agreement .checkbox-checked {
    width: 18px;
    height: 18px;
    background-image: url('../../assets/pngs/sel_press.png');
    background-repeat: no-repeat;
    cursor: pointer;
  }
  .agreement .ag-content{
    padding-left: 2px;
  }
  .agreement .ag-content a{
    color: #2D5BFF;
    cursor: pointer;
  }
</style>
